import { Injectable } from '@angular/core';


@Injectable()
export class StorageService {
    private prefix = 'sta_sso_admin_';

    public constructor() { }

    public async get(key: string): Promise<any> {
        return JSON.parse(await localStorage.getItem(this.prefix + key));
    }

    public async set(key: string, item: any): Promise<any> {
        return localStorage.setItem(this.prefix + key, JSON.stringify(item));
    }

    public async remove(key: string): Promise<any> {
        return localStorage.removeItem(this.prefix + key);
    }

    public async key(index: number): Promise<string> {
        const key = await localStorage.key(index);
        if (key !== null) {
            return key.replace(this.prefix, '');
        }

        return null;
    }

    public async clear(): Promise<void> {
        return await localStorage.clear();
    }
}
